import React from "react";
import { Panel, Overline } from "./Panel";
import { fmt } from "../../lib/api";

const phaseColor = { L1: "#00FF66", L2: "#FFCC00", L3: "#3B9DFF" };

/* Compact 3-phase mini-card for the dashboard. */
export function PhaseMini({ name, data, testid }) {
  const c = phaseColor[name];
  return (
    <Panel hover className="p-5 fade-up" data-testid={testid}>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <span className="w-2.5 h-2.5 rounded-full" style={{ background: c }} />
          <span className="font-heading font-bold text-lg">{name}</span>
        </div>
        <Overline>Phase</Overline>
      </div>
      <div className="mt-4 grid grid-cols-2 gap-3">
        <div>
          <div className="text-[10px] uppercase tracking-wider text-[var(--t2)]">Voltage</div>
          <div className="font-mono text-2xl tabular-nums">{fmt(data?.voltage, 1)}<span className="text-sm text-[var(--t2)]">V</span></div>
        </div>
        <div>
          <div className="text-[10px] uppercase tracking-wider text-[var(--t2)]">Power</div>
          <div className="font-mono text-2xl tabular-nums" style={{ color: c }}>{fmt(data?.power, 0)}<span className="text-sm text-[var(--t2)]">W</span></div>
        </div>
      </div>
    </Panel>
  );
}
